import { useFormikContext } from 'formik';
import type { ChangeEvent } from 'react';
import { useTestFunc } from '@carvana/test-attributes';

import { Background, Container, Label, StyledTextArea } from '../../theme/styles';
import { TextAreaProps } from '../../types';

const TextArea = ({ label, placeholder, name }: TextAreaProps) => {
  const {
    handleBlur,
    handleChange: handleChangeFormik,
    values
  } = useFormikContext<{ [key: string]: string }>();
  const getTestAttributes = useTestFunc();

  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    handleChangeFormik(event);
  };

  return (
    <Background>
      <Container>
        <Label>{label}</Label>
        <StyledTextArea
          id={name}
          onBlur={handleBlur}
          onChange={handleChange}
          placeholder={placeholder}
          value={values[name]}
          {...getTestAttributes(name)}
        />
      </Container>
    </Background>
  );
};

export default TextArea;
